export default "__VITE_ASSET__rN_1li4k2aIbHGs0zKW8QQ__"